import React, {ReactNode} from 'react';

import './Frame.css';
import {appdata} from "../../logic_tmp/appdata/AppData";
import {calcResource, currentLang, getImpl} from "../../backend/LgSetup";

function Frame(props) {
    let image
    if (appdata.product !== undefined)
        image =  calcResource(appdata.product["path"], getImpl(appdata.product,["miniposterResource"]))
    if (appdata.header === undefined || appdata.header.trim().length < 1)
        appdata.header = "...";
    return (
        <header className="Frame" id="header">
            <div className="container">
                <div className="row">
                    <div className="col text-center">
                        <div className="offer">
                            <time id="frameHeader" className="Frame-header">{appdata.header}</time>
                            <div className= "img1">
                                <img src={image} alt=""/>
                            </div>
                            <div>
                                {props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}
export default Frame;

